import { NgModule } from '@angular/core';
import { OauthModule } from '@monsido/oauth/oauth.module';
import { CoreAgreementService } from '@monsido/core/session/services/agreement/agreement.service';

@NgModule({
    imports: [OauthModule],
    exports: [],
    declarations: [],
    providers: [CoreAgreementService],
})
export class SessionModule {}
